import styled from "styled-components"
import {
  desktopTextStyles,
  mobileTextStyles,
} from "../shared/typography.styles"
import Breakpoints from "../shared/breakpoints"
import { ImageTile } from "../shared/solutions.imagetile"
import withAnimation, {FadeInBottom} from "../../design-system/util/withAnimation"

export const Container = styled.div`
  margin-bottom: 28px;
  
  @media (min-width: ${Breakpoints.md}) {
    margin-bottom: 0;
  }
  
`

export const TitleWrapper = styled.div`
  grid-column: 1 / -1;
  align-self: center;
  justify-self: center;
  display: flex;
  justify-content: center;
  margin-bottom: 24px;

  @media (min-width: ${Breakpoints.md}) {
    grid-column: 2 / -2;
  }

  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 1 / 7;
  }
`

export const Title = withAnimation(styled.h2`
  
  display: inline-block;
  flex-wrap: wrap;
  align-self: center;
  margin-left: auto;
  margin-right: auto;
  
  text-align: left;
  ${mobileTextStyles.MobileHeadingTwoRegular}

  @media (min-width: ${Breakpoints.md}) {
    justify-content: space-around;
    text-align: center;
    & > span {
      text-align: center;
    }

  }

  @media (min-width: ${Breakpoints.lg}) {
    
    margin-bottom: 0;
    text-align: left;
    ${desktopTextStyles.HeadingTwoRegular}
    max-width: 567px;
    & > span {
      text-align: left;
    }
  }

  color: (var(--slate));

  & > span {
    font-weight: 500;
    color: var(--burnt-orange);
    
    flex-basis: 100%; 
  }

`)

export const DescriptionContainer = styled.div`
  display: flex;
  justify-content: center;
  grid-column: 1 / -1;

  @media (min-width: ${Breakpoints.md}) {
    text-align: center;
    grid-column: 2 / -2;
  }
  @media (min-width: ${Breakpoints.lg}) {
    grid-column: 7 / -1;
    text-align: left;
  }
`

export const DescriptionText = withAnimation(styled.p`
  color: var(--body-text-grey);

  margin-right: 10px;
  justify-self: center;

  ${mobileTextStyles.MobileBodyRegular}

  @media (min-width: ${Breakpoints.md}) {
    ${desktopTextStyles.BodyText16}
  }
  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.BodyText18}
  }

`)

export const ImageTileContainer = withAnimation(styled.div`
  margin: 48px 0 0 0;

  & ${ImageTile} {
    min-height: 512px;
  }

  @media (min-width: ${Breakpoints.md}) {
    display: flex;
    flex-wrap: wrap;
    margin: 32px 15px 0 15px;

    & ${ImageTile} {
      flex: 0 1 calc(50% - 10px);
      margin: 5px 5px;
      min-height: unset;
    }
  }

  @media (min-width: ${Breakpoints.lg}) {
    & ${ImageTile} {
      flex: 0 1 calc(25% - 10px);
      max-height: 475px;
    }

    max-width: 1440px;

    padding: 64px 15px 0 15px;

    margin: 0 auto;
  }
`)
